import React from 'react';

const RightArrow = ({ width, height, className, color, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="right arrow icon"
      {...rest}
    >
      <path
        d="M1 6H17M17 6L11.5 1M17 6L11.5 11.5"
        stroke={`${color ? color : 'white'}`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RightArrow;
